// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Belt_Array from "../../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Category$Showside from "../../types/Category.bs.js";
import * as ReactContext$Showside from "../../utils/ReactContext.bs.js";
import * as NavMenu__Types$Showside from "./NavMenu__Types.bs.js";
import * as RouterProvider$Showside from "../../context/RouterProvider.bs.js";
import * as ConfigurationProvider$Showside from "../../context/ConfigurationProvider.bs.js";
var ctx = React.createContext(undefined);
var provider = ctx.Provider;
function NavMenu__Context$Provider(Props) {
  var value = Props.value;
  var children = Props.children;
  var match = ConfigurationProvider$Showside.use(undefined);
  var config = match.config;
  var activeCategory = RouterProvider$Showside.useActiveCategory(undefined, undefined, config.categories);
  var currentFullPath = React.useMemo(function () {
    if (activeCategory !== undefined) {
      return Category$Showside.getCategoryPathById(config.categories, activeCategory.id);
    } else {
      return [];
    }
  }, [activeCategory]);
  var currentL1 = Belt_Array.get(currentFullPath, 0);
  var currentL2 = Belt_Array.get(currentFullPath, 1);
  var currentL3 = Belt_Array.get(currentFullPath, 2);
  var value$1 = React.useMemo(function () {
    return {
      mode: value.mode,
      currentFullPath: currentFullPath,
      currentL1: currentL1,
      currentL2: currentL2,
      currentL3: currentL3,
      pageFlipTransitionSpeedMs: value.pageFlipTransitionSpeedMs,
      modalTransitionSpeedMs: value.modalTransitionSpeedMs,
      modalBackdropHeight: value.modalBackdropHeight,
      modalBackdropOpacity: value.modalBackdropOpacity,
      modalMaxWidth: value.modalMaxWidth,
      zIndex: value.zIndex,
      maxLevels: value.maxLevels,
      positions: value.positions,
      threeColumnLayout: value.threeColumnLayout,
      isModalOpen: value.isModalOpen,
      isIndexAllowed: value.isIndexAllowed
    };
  }, [value, currentFullPath]);
  return React.createElement(provider, {
    value: value$1,
    children: children
  });
}
NavMenu__Context$Provider.displayName = "NavMenu__Context.Provider";
var Provider = {
  provider: provider,
  make: NavMenu__Context$Provider
};
function use(param) {
  return ReactContext$Showside.useWithDefault("NavMenu__Context.use", "NavMenu__Context.Provider", ctx, NavMenu__Types$Showside.emptyCtx);
}
var initialValue;
export { initialValue, ctx, Provider, use };
/* ctx Not a pure module */